export * from './pedido-contato-form/pedido-contato-form.component';
export * from './pedido-horario/pedido-horario.component';
export * from './pedido-pagamento/pedido-pagamento.component';
export * from './pedido-retirada-entrega/pedido-retirada-entrega.component';
export * from './pedido-resumo/pedido-resumo.component';
